export const FIND_ALL_ACCESSORIES_REQUEST = "FIND_ALL_ACCESSORIES_REQUEST";
export const FIND_ALL_ACCESSORIES_SUCCESS = "FIND_ALL_ACCESSORIES_SUCCESS";
export const FIND_ALL_ACCESSORIES_FAIL = "FIND_ALL_ACCESSORIES_FAIL";

export const FIND_SINGLE_ACCESSORIES_REQUEST = "FIND_SINGLE_ACCESSORIES_REQUEST";
export const FIND_SINGLE_ACCESSORIES_SUCCESS = "FIND_SINGLE_ACCESSORIES_SUCCESS";
export const FIND_SINGLE_ACCESSORIES_FAIL = "FIND_SINGLE_ACCESSORIES_FAIL";

